
export const permissoes = [
  {
    id: 1,
    name: "Todos",
    children: [
      {
        id: 2,
        name: "Relação de Autos",
        children: [
          { id: "autos_cancelar", name: "Cancelar Autos" },
          { id: "autos_listar", name: "Visualizar Autos" },
          { id: "autos_detalhes", name: "Detalhes do Auto" },
          {
            id: "colocar_licenciamento_subjudice",
            name: "Colocar Licenciamento Subjudice"
          },
          {
            id: "retirar_licenciamento_subjudice",
            name: "Retirar Licenciamento Subjudice"
          },
          {
            id: "colocar_transferencia_subjudice",
            name: "Colocar Transfência Subjudice"
          },
          {
            id: "retirar_transferencia_subjudice",
            name: "Retirar Licenciamento Subjudice"
          },
          {
            id: "visualizar_na",
            name: "Visualizar NA"
          },
          {
            id: "visualizar_np",
            name: "Visualizar NP"
          },
          {
            id: 'antecipar_np',
            name: 'Antecipar NP'
          },
          {
            id: 'alterar_vencimento_autuacao',
            name: 'Alterar Vencimento Autuação'
          },
          {
            id: 'alterar_vencimento_penalidade',
            name: 'Alterar Vencimento Penalidade'
          }
        ]
      },
      {
        id: 3,
        name: "Defesa",
        children: [
          { id: "defesa_listar", name: "Visualizar Defesas" },
          { id: "defesa_cadastrar", name: "Cadastrar Defesas" },
          { id: "defesa_editar", name: "Editar Defesa" },
          { id: "defesa_deferir", name: "Deferir Defesa" },
          { id: "defesa_indeferir", name: "Indeferir Defesa" }
        ]
      },
      {
        id: 4,
        name: "Indicação",
        children: [
          { id: "indicacao_listar", name: "Visualizar Indicações" },
          { id: "indicacao_cadastrar", name: "Cadastrar Indicações" },
          { id: "indicacao_editar", name: "Editar Indicações" }
        ]
      },
      {
        id: 5,
        name: "Jari",
        children: [
          { id: "jari_listar", name: "Visualizar Jari" },
          { id: "jari_cadastrar", name: "Cadastrar Jari" },
          { id: "jari_editar", name: "Editar Jari" },
          { id: "jari_deferir", name: "Deferir Jari" },
          { id: "jari_indeferir", name: "Indeferir Jari" }
        ]
      },
      {
        id: 6,
        name: "Lotes de Infrações",
        children: [
          { id: "lotes_listar", name: "Visualizar Lotes" },
          { id: "lotes_editar", name: "Abrir Lotes" },
          { id: "lotes_invalidar", name: "Invalidar Lote" },
          { id: "fechar_lote", name: "Fechar Lotes" }
        ]
      },
      {
        id: 7,
        name: "Usuários",
        children: [
          { id: "users_listar", name: "Visualizar Usuários e Perfis" },
          { id: "users_cadastrar", name: "Cadastrar Usuário" },
          { id: "users_editar", name: "Editar Usuário" },
          { id: "perfis_cadastrar", name: "Cadastrar Perfil" },
          { id: "perfis_editar", name: "Editar Perfil" }
        ]
      },
      {
        id: 8,
        name: "Exceções",
        children: [
          { id: "excessoes_listar", name: "Visualizar Exceções" },
          { id: "excessoes_cadastrar", name: "Cadastrar Exceções" },
          { id: "excessoes_editar", name: "Editar Exceções" }
        ]
      },

      {
        id: 9,
        name: "Gestão de Enquadramentos",
        children: [
          { id: "infracoes_listar", name: "Visualizar Infrações" },
          { id: "infracoes_cadastrar", name: "Cadastrar Infrações" },
          { id: "infracoes_editar", name: "Editar Infrações" }
        ]
      },
      {
        id: 10,
        name: "Postagem",
        children: [{ id: "postagens", name: "Visualizar Postagens" }]
      },
      {
        id: 11,
        name: "Acompanhamento do Processo de Arquivos",
        children: [{ id: "logs", name: "Visualizar Processo de Arquivos" }]
      },
      {
        id: 14,
        name: "Agentes",
        children: [
          { id: "agentes_listar", name: "Visualizar Agentes" },
          { id: "agentes_cadastrar", name: "Cadastrar Agentes" },
          { id: "agentes_editar", name: "Editar Agentes" }
        ]
      },
      {
        id: 15,
        name: "Cadastro de Autos",
        children: [
          { id: "remessa_listar", name: "Visualizar Remessas" },
          { id: "remessa_cadastrar", name: "Cadastrar Remessas" },
          { id: "autos_cadastrar", name: "Cadastrar Auto" },
          { id: "remessa_fechar", name: "Fechar Remessa" }
        ]
      },
      {
        id: 16,
        name: "Jutificativas",
        children: [
          { id: "justificativas_listar", name: "Visualizar Justificativas" },
          { id: "justificativas_cadastrar", name: "Cadastrar Justificativas" },
          { id: "justificativas_editar", name: "Editar Justificativas" },
          { id: "justificativas_deletar", name: "Deletar Justificativas" }
        ]
      },
      {
        id: 17,
        name: "Dispositivos",
        children: [
          { id: "dispositivos_listar", name: "Visualizar Dispositivos" },
          { id: "dispositivos_cadastrar", name: "Cadastrar Dispositivos" },
          { id: "dispositivos_editar", name: "Editar Dispositivos" },
        ]
      },
      {
        id: 18,
        name: 'Gerenciamento de Autos Cancelados',
        children: [
          {
            id: 'cancelados_listar',
            name: 'Solicitações de Cancelamentos'
          }
        ]
      },
      {
        id: 19,
        name: 'Relatório de Infrações',
        children: [
          {
            id: 'enquadramento_listar',
            name: 'Visutalizar Relatório'
          }
        ]
      },
      {
        id: "consulta_condutor_veiculo",
        name: "Consultar Condutor e Veículos"
      },
      {
        id: 20,
        name: 'Relatório de Imagens Analisadas',
        children: [
          { id: 'relatorio_analises_imagens', name: 'Visualizar Imagens Validadas e Invalidadas por agente' }
        ]
      }
    ]
  }
];

export const newPermissions = async (permissoes) => {

  try {
    const data = permissoes
    const url = `${process.env.VUE_APP_URL_API}/getPermissions`
    const config = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("access_token")
      },
      body: JSON.stringify(data)
    }

    const response = await fetch(url, config)
    const json = await response.json()

    if (response.ok) {
      return json.data
    }

    return false

  } catch (e) {
    return e.data
  }
}